import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconThumbsUp16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.508 5.99A1.5 1.5 0 0 0 2 7.49v4.023a1.5 1.5 0 0 0 1.5 1.5H5V5.997zM6 5.332v7.68h4.941c.635 0 1.201-.4 1.414-.997l1.433-4.032a1.5 1.5 0 0 0-1.413-2.003H10V3c0-.961-1.223-1.369-1.8-.6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp16Filled);
